import React, { useEffect, useState } from "react";
import { Badge, Spinner, Modal, Table } from "react-bootstrap";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import "bootstrap/dist/css/bootstrap.min.css";

const WidgetCrossDocking = () => {
  const [datiRaw, setDatiRaw] = useState([]); // Tutti i dati (totali + articoli)
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const lista = data?.CROSS_DOCKING?.flat() || [];
        setDatiRaw(lista);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore Cross Docking:", err);
        setLoading(false);
      });
  }, []);

  // Filtriamo solo le testate (i raggruppamenti) per la vista principale
  const testate = datiRaw.filter((item) => item.Is_Totale === "1");

  const formattaNome = (nome) => {
    if (!nome) return "-";
    return nome.length > 22 ? nome.substring(0, 22) + "..." : nome;
  };

  const handleOpenDettaglio = (ordine) => {
    // Cerchiamo tutti gli articoli che appartengono a questa coppia di documenti
    const articoli = datiRaw.filter(
      (d) =>
        d.Is_Totale === "0" &&
        d.Doc_Cliente === ordine.Doc_Cliente &&
        d.Doc_Fornitore === ordine.Doc_Fornitore,
    );
    setSelectedOrder({ ...ordine, articoli });
    setShowModal(true);
  };

  return (
    <div
      className="bg-dark text-light widget-client2 ombra tb"
      style={{
        borderRadius: "10px",
        border: "1px solid #444",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="mt-2 text-center">
        <span className="text-title">CROSS DOCKING</span>
      </div>

      <style>{`
        .scroll-area-cd { overflow-y: auto; flex-grow: 1; padding: 15px; scrollbar-width: none; }
        .scroll-area-cd::-webkit-scrollbar { display: none; }
        .cd-card { 
            background: #252525; border: 1px solid #3d3d3d; border-radius: 12px; 
            margin-bottom: 12px; padding: 15px; cursor: pointer; transition: all 0.2s; 
        }
        .cd-card:hover { background: #2d2d2d; border-color: #b81f25; transform: translateY(-2px); }
        .flow-container { display: flex; align-items: center; justify-content: space-between; }
        .flow-box { flex: 1; min-width: 0; }
        .box-right { text-align: right; display: flex; flex-direction: column; align-items: flex-end; }
        .arrow-divider { color: #b81f25; font-size: 1.5rem; padding: 0 15px; }
        .label-tiny { font-size: 0.6rem; color: #888; text-transform: uppercase; letter-spacing: 1px; }
        .text-doc { font-size: 0.9rem; color: #ff0008; font-family: monospace; }
        .text-name { font-size: 0.85rem; font-weight: bold; color: #eee; }
        .modal-dark .modal-content { background: #1a1a1a; color: white; border: 1px solid #444; }
        .modal-dark .table { color: white; border-color: #444; }
      `}</style>

      <div className="scroll-area-cd">
        {loading ? (
          <div className="text-center mt-5">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : testate.length === 0 ? (
          <div className="text-center mt-5 text-secondary">
            Nessun cross-docking oggi
          </div>
        ) : (
          testate.map((item, idx) => (
            <div
              key={idx}
              className="cd-card shadow-sm"
              onClick={() => handleOpenDettaglio(item)}
            >
              <div className="flow-container">
                {/* LATO SINISTRA: CLIENTE */}
                <div className="flow-box">
                  <span className="label-tiny">Destinatario</span>
                  <div className="text-doc">ORD: {item.Doc_Cliente}</div>
                  <div className="text-name text-truncate">
                    {formattaNome(item.Cliente)}
                  </div>
                </div>

                <div className="arrow-divider fs-1">➜</div>
                 <Badge
                    bg="#b81f25"
                    style={{ fontSize: "0.6rem", backgroundColor: "#b81f25", color: "#ffffff" }}
                  >
                    Articoli: {item.Conteggio}
                  </Badge>

                {/* LATO DESTRA: FORNITORE */}
                <div className="flow-box box-right">
                  <span className="label-tiny">Provenienza</span>
                  <div className="text-doc">ORD: {item.Doc_Fornitore}</div>
                  <div className="text-name text-truncate">
                    {formattaNome(item.Fornitore)}
                  </div>
                 
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* MODALE DETTAGLIO ARTICOLI */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="xl"
        dialogClassName="modal-custom-xl" // Classe fondamentale per il CSS
        className="modal-dark"
      >
        <Modal.Header closeButton closeVariant="white" className="bg-white">
          <Modal.Title className="text-title text-center">
            Dettaglio Ordine: {selectedOrder?.Doc_Cliente} →{" "}
            {selectedOrder?.Doc_Fornitore}
          </Modal.Title>
        </Modal.Header>
<Modal.Body className="bg-white p-4">
  <div className="mb-4">
    <small className="text-secondary d-block text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
      Cliente: <b className="text-dark">{selectedOrder?.Cliente}</b>
    </small>
    <small className="text-secondary d-block text-uppercase" style={{ fontSize: '0.7rem', letterSpacing: '1px' }}>
      Fornitore: <b className="text-dark">{selectedOrder?.Fornitore}</b>
    </small>
  </div>

  <Table responsive borderless hover size="sm" className="mb-0">
    <thead className="border-bottom">
      <tr className="text-secondary">
        <th style={{ backgroundColor: '#b81f25', color: '#ffffff' }} className="py-2">Precodice</th>
        <th style={{ backgroundColor: '#b81f25', color: '#ffffff'  }} className="py-2">Codice Articolo</th>
        <th style={{ backgroundColor: '#b81f25', color: '#ffffff'  }} className="py-2 text-center">Quantità</th>
      </tr>
    </thead>
    <tbody>
      {selectedOrder?.articoli.map((art, i) => (
        <tr key={i} className="align-middle">
          <td className="py-2 fw-semibold">{art.precodice || "-"}</td>
          <td className="py-2 fw-bold text-dark">{art.articolo}</td>
          <td className="py-2 text-center">
            <Badge bg="white" className="px-3 text-dark">
              {art.Conteggio}
            </Badge>
          </td>
        </tr>
      ))}
      
      {selectedOrder?.articoli.length === 0 && (
        <tr>
          <td colSpan="3" className="text-center py-5 text-muted italic">
            Nessun dettaglio articolo trovato
          </td>
        </tr>
      )}
    </tbody>
  </Table>
</Modal.Body>        <Modal.Footer className=" bg-white">
          <img
            src={logo}
            alt=""
            className="mx-auto p-2"
            style={{ width: "200px" }}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WidgetCrossDocking;
